(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  var link = e.target.closest('.about-hero-actions a[href^="#"]');
  if (!link) return;
  var target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alt-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  var link = e.target.closest('.alt-hero-actions a[href^="#"]');
  if (!link) return;
  var target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

  } catch(e) { console.error(e); }
})();
})();
